<template>
  <div class="media-input">
    <span
      class="badge badge-dark badge-pill"
      v-for="(option, index) in fieldProperties.options"
      v-bind:key="index"
    >{{ option }}</span>
    <!-- FILES INPUT -->
    <input
      type="file"
      class="form-control-file mt-2"
      accept="image/x-png,image/gif,image/jpeg"
      @change="onFileSelected"
      id="mediaInput"
    />
    <!-- PROGRESS BAR -->
    <div class="progress mt-2" style="height: 4px;">
      <div class="progress-bar" id="progressBar" role="progressbar" style="width: 0%;" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
    <!-- PREVIEW IMAGES -->
    <div
      v-for="(thumb, i) in thumbs"
      v-bind:key="i"
      class="preview-image-container"
      id="cvContainer"
    >
      <div
        v-if="loadingCV"
        id="cvLoadContainer"
      >
        <p>Running Computer Vision...</p>
        <i class="fas fa-robot"></i><br>
        <i class="fas fa-cog fa-spin"></i>
      </div><!-- /#cvLoadContainer -->
      <div @click="deleteMedia(thumb, i)" class="preview-image-delete clickable">
        <i class="far fa-times"></i>
      </div><!-- /.preview-image-delete -->
      <img :src="thumb.url" width="100%" id="cvImg">
    </div><!-- /.preview-image-container -->
    <div v-if="showClassCounts">
      <ul>
        <li
          v-for="className in mediaPayload[0].classes"
          v-bind:key="className"
        ><strong>{{ className }}:</strong> {{ mediaPayload[0].classCounts[className] }}</li>
      </ul>
    </div>
  </div><!-- /.media-input -->
</template>

<script>
import firebase from 'firebase/compat/app'
import axios from 'axios'

export default {
  data () {
    return {
      mediaPayload: [],
      thumbs: [],
      loadingCV: false,
      classes: [],
      classObjs: {},
      showClassCounts: false
    }
  },
  props: ['mediaObject', 'fieldProperties'],
  created () {
    this.mediaPayload = []
    if (this.mediaObject) {
      this.mediaPayload = this.mediaObject
      this.mediaPayload.forEach((mediaItem, i) => {
        const self = this
        firebase.storage().ref(mediaItem.path).getDownloadURL().then(url => {
          self.thumbs.push({
            url: url,
            path: mediaItem.path,
            small: mediaItem.small,
            medium: mediaItem.medium,
            large: mediaItem.large
          })
          setTimeout(() => {
            const img = document.getElementById('cvImg')
            const displayWidth = img.clientWidth
            const displayHeight = img.clientHeight
            const scaleX = displayWidth / img.naturalWidth
            const scaleY = displayHeight / img.naturalHeight
            this.drawPredictions(mediaItem.cv, scaleX, scaleY)
          }, 1000)
        })
      })
    }
  },
  methods: {
    drawPredictions (response, scaleX, scaleY) {
      this.classes = []
      this.classObjs = {}

      const container = document.getElementById('cvContainer')

      // SETUP LABELS AND COLORS
      const colors = ['red', 'yellow', 'orange', 'blue', 'green', 'purple', 'pink', 'black', 'white', 'grey']
      const classLabels = []
      response.predictions.forEach(prediction => {
        if (!classLabels.includes(prediction.class)) {
          classLabels.push(prediction.class)
        }
      })
      classLabels.forEach((label, i) => {
        this.classes.push({
          label: label,
          color: colors[i]
        })
        this.classObjs[label] = {
          color: colors[i]
        }
      })

      response.predictions.forEach(prediction => {
        const div = document.createElement('div')
        div.className = 'prediction'
        div.style.width = `${prediction.width * scaleX}px`
        div.style.height = `${prediction.height * scaleY}px`
        div.style.left = `${prediction.x * scaleX}px`
        div.style.top = `${prediction.y * scaleY}px`
        div.style.borderColor = this.classObjs[prediction.class].color

        const text = document.createTextNode(`${prediction.confidence.toFixed(2)}`)
        div.appendChild(text)

        container.appendChild(div)
      })

      this.showClassCounts = true
    },
    requestCV () {
      this.showClassCounts = false
      this.loadingCV = true
      // Create a cvRequest document with
      console.log('Requesting CV')
      console.log(this.thumbs)
      console.log(this.fieldProperties)
      const postObject = {
        imageURL: this.thumbs[0].url,
        modelURL: this.fieldProperties.cvSettings.modelURL,
        roboflowAPIKey: this.fieldProperties.cvSettings.roboflowAPIKey
      }
      console.log(postObject)
      // axios.post('https://api.efficientvineyard.com/cv', postObject).then(response => {
      axios.post('https://myev-roboflow-inference-qy5krwgaaa-uc.a.run.app', postObject).then(response => {
        console.log('Got CV response')
        console.log(response.data)
        this.mediaPayload[0].cv = response.data

        // Glean Values from the response
        this.mediaPayload[0].classes = []
        this.mediaPayload[0].classCounts = {}
        response.data.predictions.forEach(prediction => {
          // Initialize the count to 0 if the class doesn't exist, and increment it
          this.mediaPayload[0].classCounts[prediction.class] = (this.mediaPayload[0].classCounts[prediction.class] || 0) + 1

          // Add the class to the classes array if it's not already there
          if (!this.mediaPayload[0].classes.includes(prediction.class)) {
            this.mediaPayload[0].classes.push(prediction.class)
          }
        })

        // Stop loading
        this.loadingCV = false

        const img = document.getElementById('cvImg')
        const displayWidth = img.clientWidth
        const displayHeight = img.clientHeight
        const scaleX = displayWidth / img.naturalWidth
        const scaleY = displayHeight / img.naturalHeight
        this.drawPredictions(response.data, scaleX, scaleY)

        this.$emit('mediaDelivery', this.mediaPayload)
      }).catch(err => {
        console.log(err.message)
      })
    },
    onFileSelected (e) {
      const self = this
      function getFormattedTime () {
        var today = new Date()
        var y = today.getFullYear()
        var m = today.getMonth() + 1
        var d = today.getDate()
        return y + '-' + m + '-' + d + '-'
      }
      function s4 () {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1)
      }

      // for (var i = 0; i < e.target.files.length; i++) {
      // JUST THE FIRST IMAGE
      for (var i = 0; i < 1; i++) {
        console.log(i)
        const mediaId = getFormattedTime() + s4()
        // Get the image item
        const file = e.target.files[i]
        const fileName = mediaId + file.name
        const smallFileName = fileName.replace(/(\.[\w\d_-]+)$/i, '_500x500$1')
        const mediumFileName = fileName.replace(/(\.[\w\d_-]+)$/i, '_1000x1000$1')
        const largeFileName = fileName.replace(/(\.[\w\d_-]+)$/i, '_2000x2000$1')
        // Cunstruct the path and storage reference for Firebase
        const mediaPath = 'datasets/dynamic/' + this.$store.state.collector.datasetId + '/images/' + fileName
        const smallMediaPath = 'datasets/dynamic/' + this.$store.state.collector.datasetId + '/images/thumbs/' + smallFileName
        const mediumMediaPath = 'datasets/dynamic/' + this.$store.state.collector.datasetId + '/images/thumbs/' + mediumFileName
        const largeMediaPath = 'datasets/dynamic/' + this.$store.state.collector.datasetId + '/images/thumbs/' + largeFileName
        // if (this.blockUpload) {
        //   console.log('Block upload detected')
        //   mediaPath = 'farms/' + this.$store.state.farm.id + '/images/' + fileName
        //   smallMediaPath = 'farms/' + this.$store.state.farm.id + '/images/thumbs/' + smallFileName
        //   mediumMediaPath = 'farms/' + this.$store.state.farm.id + '/images/thumbs/' + mediumFileName
        //   largeMediaPath = 'farms/' + this.$store.state.farm.id + '/images/thumbs/' + largeFileName
        // }
        console.log(mediaPath)
        console.log(smallMediaPath)
        console.log(mediumMediaPath)
        console.log(largeMediaPath)
        this.mediaPayload.push({
          path: mediaPath,
          small: smallMediaPath,
          medium: mediumMediaPath,
          large: largeMediaPath
        })
        // Set the Firebase storage reference for this media item
        const storageRef = firebase.storage().ref(mediaPath)
        // Upload the file to Firebase with task variable. Tag
        // customMetadata.userId for usageFinalize attribution.
        const task = storageRef.put(file, {
          customMetadata: {
            userId: (this.$store.state.currentUser && this.$store.state.currentUser.uid) || ''
          }
        })
        // Listen for state changes as media item is being uploaded
        task.on('state_changed', function progress (snapshot) {
          // Set percentage of the progress bat
          // todo - Make this progress bar smarter to take account of all media items being uploaded at the same time.
          const percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100 + '%'
          document.getElementById('progressBar').style.width = percentage
        },
        function error (err) {
          console.log('errors: ' + err)
        },
        function complete () {
          document.getElementById('progressBar').style.width = 0
          firebase.storage().ref(mediaPath).getDownloadURL().then(url => {
            self.thumbs.push({
              url: url,
              path: mediaPath,
              small: smallMediaPath,
              medium: mediumMediaPath,
              large: largeMediaPath
            })
            self.requestCV()
          })
        })
      }
      // setTimeout(function () {
      //   self.$emit('mediaDelivery', self.mediaPayload)
      // }, 2000)
    },
    deleteMedia (media, i) {
      this.showClassCounts = false
      console.log(media)
      firebase.storage().ref(media.path).delete()
      firebase.storage().ref(media.small).delete()
      firebase.storage().ref(media.medium).delete()
      firebase.storage().ref(media.large).delete()
      this.thumbs.splice(i, 1)
      this.mediaPayload.splice(i, 1)
      this.$emit('mediaDelivery', this.mediaPayload)
    }
  }
}
</script>

<style scoped>
.preview-image-container {
  position: relative;
  display: inline-block;
  padding: 10px;
  background-color: #333;
  margin: 10px;
  border-radius: 4px;
}
.preview-image-delete {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: red;
  border-radius: 50px;
  padding: 0px 7px
}
#cvLoadContainer {
  position: absolute;
  background-color: rgba(255,255,255,0.8);
  width: calc(100% - 20px);
  height: calc(100% - 20px);
  text-align: center;
  padding-top: 50px;
  font-size: 50px;
  color: black;
}
#cvLoadContainer p {
  font-size: 18px;
}
</style>
